import { createReducer } from '../reducerUtil'
import cuid from 'cuid'
import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_HISTORY,
  SET_MODE,
  CHANGE_KEY_TEXT,
  SAVE_LOCAL_CHOICES_LIST,
  SET_TITLE_OBJ,
  SET_SAVED_LISTS,
  INSTANT_INIT,
  RESET_INITIAL_STATE,
  REPLACE_STATE,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
  SET_CHOICE_HD_IMAGES,
} from './constants'

const initialState = {
  resultSelected: '',
  resultPieColor: null,
  resultIndex: -1,
  history: [],
  mode: 0,
  choices: [],
  title: {
    active: false,
    text: '',
    description: '',
    popup: '',
  },
  turnTable: null,
  turnTableSize: 300,
  // pastIP: '',
  inputKeyText: cuid(),
  // listName: '',
  savedChoicesList: {
    // A: { name: '', choices: [] },
    // B: { name: '', choices: [] },
    // C: { name: '', choices: [] },
    // D: { name: '', choices: [] },
    // E: { name: '', choices: [] },
    // F: { name: '', choices: [] },
    // G: { name: '', choices: [] },
    // H: { name: '', choices: [] },
    // I: { name: '', choices: [] },
    // J: { name: '', choices: [] },
    // K: { name: '', choices: [] },
    // L: { name: '', choices: [] },
    // M: { name: '', choices: [] },
    // N: { name: '', choices: [] },
    // O: { name: '', choices: [] },
  },
  // totalImages: 0,
  mysteryWheelOn: false,
  mysteryResultOn: false,
  scores: [],
  autoAddCount: false,
  choiceHDImages: [],
}

export const setResultSelected = (state, payload) => {
  return {
    ...state,
    resultSelected: payload.result,
    resultIndex: payload.resultIndex,
    resultPieColor: payload.resultPieColor,
  }
}

export const setChoices = (state, payload) => {
  return {
    ...state,
    choices: payload.choices,
    // turnTable: payload.nullTurntable ? null : state.turnTable,
    turnTable: null,
  }
}

export const setHistory = (state, payload) => {
  return {
    ...state,
    history: payload.history,
  }
}

export const setMode = (state, payload) => {
  return {
    ...state,
    mode: payload.mode,
  }
}

export const showTurntable = (state, payload) => {
  return {
    ...state,
    turnTable: payload.turntable,
  }
}

export const setTurntableSize = (state, payload) => {
  return {
    ...state,
    turnTable: state.turnTableSize === payload.size ? state.turnTable : null,
    turnTableSize: payload.size,
  }
}

export const changeKeyText = (state, payload) => {
  return {
    ...state,
    inputKeyText: cuid(),
  }
}

export const setListName = (state, payload) => {
  return {
    ...state,
    listName: payload.name,
  }
}

export const saveLocalChoicesList = (state, payload) => {
  return {
    ...state,
    savedChoicesList: {
      ...state.savedChoicesList,
      [payload.data.id]: payload.data,
    },
  }
}

export const setSavedLists = (state, payload) => {
  return {
    ...state,
    savedChoicesList: payload.lists,
  }
}

// export const setTitleActive = (state, payload) => {
//   return {
//     ...state,
//     title: {
//       ...state.title,
//       active: payload.active,
//     },
//   }
// }

// export const setTitleText = (state, payload) => {
//   return {
//     ...state,
//     title: {
//       ...state.title,
//       text: payload.text,
//     },
//   }
// }

export const setTitleObj = (state, payload) => {
  return {
    ...state,
    title: {
      ...state.title,
      ...payload.obj,
    },
  }
}

export const instantInit = (state, payload) => {
  if (!payload.previousState) {
    return {
      ...state,
    }
  } else {
    return {
      ...payload.previousState,
    }
  }
}

export const resetInitialState = (state, payload) => {
  const { savedChoicesList, turnTableSize, ...rest } = initialState
  return {
    ...state,
    ...rest,
  }
}

export const replaceState = (state, payload) => {
  return {
    ...state,
    ...payload.data,
    inputKeyText: cuid(),
  }
}

export const setMysteryWheelOn = (state, payload) => {
  return {
    ...state,
    mysteryWheelOn: payload.status,
    turnTable: null,
  }
}

export const setMysteryResultOn = (state, payload) => {
  return {
    ...state,
    mysteryResultOn: payload.status,
  }
}

export const updateMysterySettings = (state, payload) => {
  return {
    ...state,
    mysteryWheelOn: payload.mysteryWheelOn,
    mysteryResultOn: payload.mysteryResultOn,
  }
}

export const setScores = (state, payload) => {
  return {
    ...state,
    scores: payload.scores,
  }
}

export const setAutoAddCount = (state, payload) => {
  return {
    ...state,
    autoAddCount: payload.status,
  }
}

export const setChoiceHDImages = (state, payload) => {
  return {
    ...state,
    choiceHDImages: payload.choiceHDImages.sort((a, b) => a.index - b.index),
  }
}

export default createReducer(initialState, {
  [SHOW_TURNTABLE]: showTurntable,
  [SET_RESULT_SELECTED]: setResultSelected,
  [SET_CHOICES]: setChoices,
  [SET_MODE]: setMode,
  [SET_HISTORY]: setHistory,
  [SET_TURNTABLE_SIZE]: setTurntableSize,
  [CHANGE_KEY_TEXT]: changeKeyText,
  [SAVE_LOCAL_CHOICES_LIST]: saveLocalChoicesList,
  [SET_TITLE_OBJ]: setTitleObj,
  [SET_SAVED_LISTS]: setSavedLists,
  [INSTANT_INIT]: instantInit,
  [RESET_INITIAL_STATE]: resetInitialState,
  [REPLACE_STATE]: replaceState,
  [SET_MYSTERY_WHEEL_ON]: setMysteryWheelOn,
  [SET_MYSTERY_RESULT_ON]: setMysteryResultOn,
  [UPDATE_MYSTERY_SETTINGS]: updateMysterySettings,
  [SET_SCORES]: setScores,
  [SET_AUTO_ADD_COUNT]: setAutoAddCount,
  [SET_CHOICE_HD_IMAGES]: setChoiceHDImages,
})
